export const formatBillingCurrency = (
  signedValue?: number,
  collapseWholeNumbers = false,
  symbol = '$'
) => {
  const value = Math.abs(signedValue || 0);
  const sign = signedValue && signedValue < 0 ? '-' : '';

  // Special zero case
  if (!value) {
    if (collapseWholeNumbers) {
      return `${sign}${symbol}0`;
    }
    return `${sign}${symbol}0.00`;
  }

  // Whole numbers
  if (value % 1 === 0) {
    if (collapseWholeNumbers) {
      return `${sign}${symbol}${value.toLocaleString()}`;
    }
    return `${sign}${symbol}${value.toLocaleString()}.00`;
  }

  // Decimal numbers
  return `${sign}${symbol}${value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatBillingCurrencyFromString = (
  value?: string | number,
  collapseWholeNumbers = false,
  symbol = '$'
) => {
  const parsed = Number(value);

  return formatBillingCurrency(parsed, collapseWholeNumbers, symbol);
};
